import React, { Component } from 'react'
import { connect } from 'react-redux';
import { change as changeFieldValue, reduxForm, reset } from 'redux-form';
import { withRouter } from 'react-router-dom';
import {
    getGestorEmpresa,
    getOperadorEmpresa,
    getPerfisVendedores,
    getAdminEmpresa,
    getOperadorRemarcacao,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import selecionarEncomenda from '../../actions/encomenda/selecionarEncomenda';
import selecionarPedido from '../../actions/pedido/selecionarPedido';
import { situacaoTransmissaoCteOs } from '../../util/constantsUtil';

class AcoesEncomenda extends Component {

    exibeBotaoTransmissaoCte() {
        if (this.props.encomenda.ultimoHistorico != null && this.props.encomenda.ultimoHistorico.situacaoPedido == 'CANCELADO') {
            return false;
        }

        if (this.props.encomenda.ultimoHistoricoEmissaoCte == null) {
            return true;
        }
        if (this.props.encomenda.ultimoHistoricoEmissaoCte != null
            && this.props.encomenda.ultimoHistoricoEmissaoCte.situacaotransmissao.chave == situacaoTransmissaoCteOs.erro) {
            return true;
        }

        return false;
    }

    exibeBotaoImprimirNota() {
        if (this.props.encomenda.ultimoHistoricoEmissaoCte != null
            && this.props.encomenda.ultimoHistoricoEmissaoCte.situacaotransmissao.chave == situacaoTransmissaoCteOs.sucesso) {
            return true;
        }

        return false;
    }

    preencherValoresCte(encomenda) {
        this.props.changeFieldValue('formularioTransmitirCte',
            'rntrc', encomenda.rntrc);

        this.props.changeFieldValue('formularioTransmitirCte',
            'chaveNfe', encomenda.chaveNfe);

        if (encomenda.tipoServicoCte) {
            this.props.changeFieldValue('formularioTransmitirCte', 'tipoServicoCte', {
                label: encomenda.tipoServicoCte.valor,
                value: encomenda.tipoServicoCte.chave,
            });
        }

        if (encomenda.naturezaOperacao){
            const natureza = this.props.naturezasOperacoes.find(it => it.chave == encomenda.naturezaOperacao);

            if (natureza) {
                this.props.changeFieldValue('formularioTransmitirCte', 'naturezaOperacao', {
                    label: natureza.valor,
                    value: natureza.chave,
                });
            }

        }
    }    

    preencherValoresFormulario(encomenda) {
        const cartao = encomenda.formasPagamento.filter(f => f.tipo === 'Cartão');
        const dinheiro = encomenda.formasPagamento.filter(f => f.tipo === 'Dinheiro');

        this.props.changeFieldValue('formGerenciarPedido',
            'valorTotal', encomenda.valor);

        if (cartao.length > 0) {
            this.props.changeFieldValue('formGerenciarPedido',
                'idFormaPagamento', cartao[0].idFormaPagamento);

            this.props.changeFieldValue('formGerenciarPedido',
                'numeroComprovante', cartao[0].numeroComprovante);

            this.props.changeFieldValue('formGerenciarPedido',
                'quantidadeParcelas', cartao[0].quantidadeParcelas);

            this.props.changeFieldValue('formGerenciarPedido',
                'valorCartao', cartao[0].valor);

            this.props.changeFieldValue('formGerenciarPedido',
                'urlComprovante', cartao[0].urlComprovante);

            this.props.changeFieldValue('formGerenciarPedido',
                'nomeComprovante', cartao[0].nomeComprovante);

            this.props.changeFieldValue('formGerenciarPedido',
                'arquivo', cartao[0].arquivo);

            this.props.changeFieldValue('formGerenciarPedido',
                'cartao', true);
        }

        if (dinheiro.length > 0) {
            this.props.changeFieldValue('formGerenciarPedido',
                'idFormaPagamento', dinheiro[0].idFormaPagamento);

            this.props.changeFieldValue('formGerenciarPedido',
                'valorDinheiro', dinheiro[0].valor);

            this.props.changeFieldValue('formGerenciarPedido',
                'dinheiro', true);
        }
    }

    preencherValoresFormularioIncluirFormaPagamento(encomenda) {
        const cartao = encomenda.formasPagamento.filter(f => f.tipo === 'Cartão');

        this.props.changeFieldValue('formIncluirFormarPagamento',
            'valorTotal', encomenda.valor);

        if (cartao.length > 0) {
            this.props.changeFieldValue('formIncluirFormarPagamento',
                'idFormaPagamento', cartao[0].idFormaPagamento);

            this.props.changeFieldValue('formIncluirFormarPagamento',
                'numeroComprovante', cartao[0].numeroComprovante);

            this.props.changeFieldValue('formIncluirFormarPagamento',
                'quantidadeParcelas', cartao[0].quantidadeParcelas);

            this.props.changeFieldValue('formIncluirFormarPagamento',
                'valorCartao', cartao[0].valor);

            this.props.changeFieldValue('formIncluirFormarPagamento',
                'urlComprovante', cartao[0].urlComprovante);

            this.props.changeFieldValue('formIncluirFormarPagamento',
                'nomeComprovante', cartao[0].nomeComprovante);

            this.props.changeFieldValue('formIncluirFormarPagamento',
                'arquivo', cartao[0].arquivo);

            this.props.changeFieldValue('formIncluirFormarPagamento',
                'cartao', true);
        }
    }

    preencherValoresFormularioAlterarFormaPagamento(encomenda) {
        const cartao = encomenda.formasPagamento.filter(f => f.tipo === 'Cartão');
        const dinheiro = encomenda.formasPagamento.filter(f => f.tipo === 'Dinheiro');
        const pix = encomenda.formasPagamento.filter(f => f.tipo === 'PIX');

        this.props.changeFieldValue('formAlterarFormaPagamento',
            'valorTotal', encomenda.valor);

        if (cartao.length > 0) {
            this.props.changeFieldValue('formAlterarFormaPagamento',
                'numeroComprovante', cartao[0].numeroComprovante);

            this.props.changeFieldValue('formAlterarFormaPagamento',
                'quantidadeParcelas', cartao[0].quantidadeParcelas);

            this.props.changeFieldValue('formAlterarFormaPagamento',
                'valorCartao', cartao[0].valor);

            this.props.changeFieldValue('formAlterarFormaPagamento',
                'urlComprovante', cartao[0].urlComprovante);

            this.props.changeFieldValue('formAlterarFormaPagamento',
                'nomeComprovante', cartao[0].nomeComprovante);

            this.props.changeFieldValue('formAlterarFormaPagamento',
                'arquivo', cartao[0].arquivo);

            this.props.changeFieldValue('formAlterarFormaPagamento',
                'cartao', true);
        }

        if (pix.length > 0) {
            this.props.changeFieldValue('formAlterarFormaPagamento',
                'numeroComprovantePIX', pix[0].numeroComprovante);

            this.props.changeFieldValue('formAlterarFormaPagamento',
                'valorPIX', pix[0].valor);

            this.props.changeFieldValue('formAlterarFormaPagamento',
                'urlComprovantePIX', pix[0].urlComprovante);

            this.props.changeFieldValue('formAlterarFormaPagamento',
                'nomeComprovantePIX', pix[0].nomeComprovante);

            this.props.changeFieldValue('formAlterarFormaPagamento',
                'arquivoPIX', pix[0].arquivo);

            this.props.changeFieldValue('formAlterarFormaPagamento',
                'pix', true);
        }

        if (dinheiro.length > 0) {
            this.props.changeFieldValue('formAlterarFormaPagamento',
                'dinheiro', true);
            this.props.changeFieldValue('formAlterarFormaPagamento',
                'valorDinheiro', dinheiro[0].valor);
        }
    }

    exibirAlteracaoFormaPagamento() {
        if (this.props.encomenda.sePodeAlterarFormaPagamento) {
            return (<a className="dropdown-item" data-toggle="modal" data-target="#modalAlterarFormaPagamento"
                onClick={() => {
                    this.props.selecionarPedido({ id: this.props.encomenda.idPedido })
                    this.preencherValoresFormularioAlterarFormaPagamento(this.props.encomenda)
                }}> Alterar forma de pagamento
            </a>)
        }
    }

    exibirIncluirComprovante() {
        if (this.props.encomenda.sePodeAlterarFormaPagamento) {
            const cartao = this.props.encomenda.formasPagamento.filter(f => f.tipo === 'Cartão');
            if (cartao.length > 0) {
                return (
                    <a className="dropdown-item" data-toggle="modal" data-target="#modalInformarComprovantePagamento"
                        onClick={() => {
                            this.props.selecionarPedido({ id: this.props.encomenda.idPedido })
                            this.preencherValoresFormularioIncluirFormaPagamento(this.props.encomenda)
                        }}> Incluir comprovante de pagamento
                    </a>)
            }
        }
        return ''
    }

    exibirCancelarPedido() {
        if (this.props.encomenda.sePodeCancelar) {
            return (
                <a className="dropdown-item" data-toggle="modal" data-target="#modalConfirmacaoCancelamentoEncomenda"
                    onClick={() => {
                        this.props.selecionarEncomenda(this.props.encomenda);
                        this.props.changeFieldValue('formularioCancelamentoEncomenda',
                            'observacao', '');
                    }}> Cancelar Encomenda
                </a>
            )
        }
    }

    exibirImprimirCupom() {
        if (this.props.encomenda.ultimoHistorico.situacaoPedido !== 'CANCELADO') {
            const url = `/recibo-encomenda?encomenda=${this.props.encomenda.id}`;
            return (
                <div>
                    <a className="dropdown-item"
                        onClick={() => {
                            this.props.history.push(url)
                        }}> Emitir Cupom
                    </a>
                </div>
            )
        }
    }
    
    exibirBotaoHistoricoPedido() {
        return (<a className="dropdown-item" data-toggle="modal"
            data-target="#modalHistoricoEncomenda" onClick={() => {
                this.props.selecionarHistoricos(this.props.encomenda.historicos, this.props.encomenda.idPedido)
            }}>
            Histórico Pedido
        </a>)
    }

    exibirImagensEncomenda() {
        return (<a className="dropdown-item" data-toggle="modal"
            data-target="#modalImagensEncomenda" onClick={() => {
                this.props.preencherModalImagensEncomenda(this.props.encomenda.imagens)
                this.props.selecionarEncomenda(this.props.encomenda);
            }}>
            Alterar imagens encomenda
        </a>)
    }

    exibirInformarEntregaEncomenda() {
        return (<a className="dropdown-item" data-toggle="modal"
            data-target="#modalInformarEntregaEncomenda" onClick={() => {
                this.props.changeFieldValue('formularioInformarEntregaEncomenda', 'observacao', this.props.encomenda.observacaoEntrega);
                this.props.preencherModalInformarEntregaEncomenda(this.props.encomenda.imagensInformarEntrega)
                this.props.selecionarEncomenda(this.props.encomenda); 
            }}>
            Informar entrega
        </a>)
    }

    exibirTransmitirCte() {
        if (this.exibeBotaoTransmissaoCte()) {
            return (
                <a className="dropdown-item" data-toggle="modal"
                    data-target="#modalTransmitirCte"  onClick={() => {
                        this.props.selecionarEncomenda(this.props.encomenda);
                        this.preencherValoresCte(this.props.encomenda);
                    }}>
                    Transmitir CT-e
                </a>
            )
        }

        return ''
    }

    exibirImprimirCte() {
        if (this.exibeBotaoImprimirNota()) {
            return (
                <a className="dropdown-item" data-toggle="modal"
                    data-target="#pageImprimeCte"  onClick={() => {
                        const url = `/nota-fiscal-cte?encomenda=${this.props.encomenda.id}`;
                        this.props.history.push(url)
                    }}>
                    Imprimir CT-e
                </a>
            )
        }

        return ''
    }

    render() {
        return (
            <div className="col-lg-1 col-xl-1">
                <div className="dropdown">
                    <span className="titulo-mobile">Ações:</span>
                    <button className="btn btn-link btn-acoes btn-sm dropdown" type="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

                        <i className="material-icons">
                            &#xe5d4;
                        </i>

                    </button>
                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                            getAdminEmpresa(this.props.empresaSelecionada.id),
                            getOperadorEmpresa(this.props.empresaSelecionada.id),
                            getOperadorRemarcacao(this.props.empresaSelecionada.id),
                            getGestorEmpresa(this.props.empresaSelecionada.id)
                        ]}>
                            {this.exibirCancelarPedido()}
                            {this.exibirAlteracaoFormaPagamento()}
                        </Autorizacao>
                        {this.exibirBotaoHistoricoPedido()}
                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                            getGestorEmpresa(this.props.empresaSelecionada.id),
                            getOperadorEmpresa(this.props.empresaSelecionada.id),
                            ...getPerfisVendedores(this.props.empresaSelecionada.id)
                        ]}>
                            {this.exibirIncluirComprovante()}
                            {this.exibirImprimirCupom()}
                            {this.exibirImagensEncomenda()}
                            {this.exibirInformarEntregaEncomenda()}
                        </Autorizacao>

                        <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                            getAdminEmpresa(this.props.empresaSelecionada.id),
                            getGestorEmpresa(this.props.empresaSelecionada.id)
                        ]}>
                            {this.exibirTransmitirCte()}
                            {this.exibirImprimirCte()}
                        </Autorizacao>
                    </div>
                </div>
            </div>
        )
    }
}

export const
    mapStateToProps = state => (
        {
            empresaSelecionada: state.empresaSelecionada,
            naturezasOperacoes: state.opcoesFiltrosEmissaoesCte.naturezasOperacoes,
        });

export default withRouter(connect(mapStateToProps, {
    selecionarEncomenda, selecionarPedido, changeFieldValue, reset
})(reduxForm({
    form: 'formularioCadastroEncomenda'
})(AcoesEncomenda)))
